import { useRef } from 'react'

/**
 * Vaste React-sleutels voor een bewerkbare lijst zonder eigen id's (artikelblokken, regels in de
 * teksteditor). Los van de positie, zodat focus, cursor en invoer bij de juiste rij blijven na
 * verplaatsen of verwijderen. Wijzigt de lengte van buitenaf, dan groeit of krimpt de lijst mee.
 *
 * Het bijwerken tijdens het renderen is idempotent (zelfde lengte = niets), dus veilig bij een
 * herhaalde of afgebroken render.
 */
export function useStableKeys(length: number) {
  const ids = useRef<string[]>([])
  const next = useRef(0)
  while (ids.current.length < length) ids.current.push(`k${next.current++}`)
  if (ids.current.length > length) ids.current.length = length

  return {
    keys: ids.current,
    /** Roep aan vóór je de lijst zelf verplaatst. */
    move(from: number, to: number) {
      if (to < 0 || to >= ids.current.length) return
      const copy = [...ids.current]
      const [item] = copy.splice(from, 1)
      copy.splice(to, 0, item)
      ids.current = copy
    },
    /** Roep aan vóór je de rij zelf weghaalt. */
    remove(i: number) {
      ids.current = ids.current.filter((_, j) => j !== i)
    },
    /** Voor ongedaan maken: de sleutels van vóór de wijziging terugzetten. */
    snapshot: () => ids.current,
    restore(snapshot: string[]) {
      ids.current = snapshot
    },
  }
}
